import { render, staticRenderFns } from "./Accept.vue?vue&type=template&id=502a9af2&scoped=true"
import script from "./Accept.vue?vue&type=script&lang=js"
export * from "./Accept.vue?vue&type=script&lang=js"
import style0 from "./Accept.vue?vue&type=style&index=0&id=502a9af2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502a9af2",
  null
  
)

export default component.exports